<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 6V18"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24 6V18"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 27H63"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57 12H15C11.685 12 9 14.685 9 18V57C9 60.315 11.685 63 15 63H57C60.315 63 63 60.315 63 57V18C63 14.685 60.315 12 57 12Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.039 38.187C20.625 38.187 20.289 38.523 20.292 38.937C20.292 39.351 20.628 39.687 21.042 39.687C21.456 39.687 21.792 39.351 21.792 38.937C21.792 38.523 21.456 38.187 21.039 38.187"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.039 38.187C35.625 38.187 35.289 38.523 35.292 38.937C35.292 39.351 35.628 39.687 36.042 39.687C36.456 39.687 36.792 39.351 36.792 38.937C36.792 38.523 36.456 38.187 36.039 38.187"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M51.039 38.187C50.625 38.187 50.289 38.523 50.292 38.937C50.292 39.351 50.628 39.687 51.042 39.687C51.456 39.687 51.792 39.351 51.792 38.937C51.792 38.523 51.456 38.187 51.039 38.187"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.039 50.187C20.625 50.187 20.289 50.523 20.292 50.937C20.292 51.351 20.628 51.687 21.042 51.687C21.456 51.687 21.792 51.351 21.792 50.937C21.792 50.523 21.456 50.187 21.039 50.187"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.039 50.187C35.625 50.187 35.289 50.523 35.292 50.937C35.292 51.351 35.628 51.687 36.042 51.687C36.456 51.687 36.792 51.351 36.792 50.937C36.792 50.523 36.456 50.187 36.039 50.187"
      stroke="currentColor)"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1448_172907"
        x1="46.5"
        y1="18"
        x2="52.1471"
        y2="16.5882"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1448_172907"
        x1="22.5"
        y1="18"
        x2="28.1471"
        y2="16.5882"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1448_172907"
        x1="9"
        y1="28.5"
        x2="9.33231"
        y2="22.5185"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1448_172907"
        x1="9"
        y1="63"
        x2="59.9168"
        y2="9.08809"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1448_172907"
        x1="19.542"
        y1="40.437"
        x2="22.542"
        y2="37.437"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1448_172907"
        x1="34.542"
        y1="40.437"
        x2="37.542"
        y2="37.437"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1448_172907"
        x1="49.542"
        y1="40.437"
        x2="52.542"
        y2="37.437"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1448_172907"
        x1="19.542"
        y1="52.437"
        x2="22.542"
        y2="49.437"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1448_172907"
        x1="34.542"
        y1="52.437"
        x2="37.542"
        y2="49.437"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
    </defs>
  </svg>
</template>
